module.exports = __webpack_public_path__ + "static/media/golden-gate-bridge.74cf5a05.jpg";